import { ProductType } from '@/types/enum/upload';
import { Product } from '@/types/api/Model/Product';
import { Product_Type } from '@/types/api/Model/ProductType';

export function mapProductTypeName(name: string) {
  //TOBEREMOVED
  switch (name.toLowerCase()) {
    case 'zäune':
      return ProductType.fence;
    case 'geländer':
      return ProductType.railling;
    case 'photovoltaikanlagen':
      return ProductType.photovoltaic;
    case 'möbel':
      return ProductType.furniture;
    case 'sonstige':
      return ProductType.miscellaneous;
    case 'küchen':
      return ProductType.kitchens;
    case 'balkone':
      return ProductType.balconies;
    case 'lineare beleuchtung':
      return ProductType.linear_lighting;
    case 'punktuelle beleuchtung':
      return ProductType.spotlighting;
    case 'duschen und bäder':
      return ProductType.shower_baths;
    case 'orthesen':
      return ProductType.orthoses;
    case 'orthesen modelle':
      return ProductType.orthoses_models;
    case 'brace':
      return ProductType.brace;
    case 'hütten':
      return ProductType.cabins;
    case 'badewanne':
      return ProductType.bathtubs;
    case 'vordach und windfang':
      return ProductType.awnings;
  }
  return name;
}

function isProductType(product_type: Product | Product_Type, ...types: ProductType[]): boolean {
  const productTypeName = (product_type as any)?.type?.name ?? product_type?.name;
  if (!productTypeName) return false;

  if (types && types.length) {
    for (const i in types) {
      if (mapProductTypeName(productTypeName).toLocaleLowerCase() == types[i].toLowerCase()) return true;
    }
  }
  return false;
}

const type_mapper = {
  isProductType: isProductType,
};

export default type_mapper;
